// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xq yc","addMyListButton":"xr yn"};